// src/components/eventos/ModalVerEvento.js
import React from 'react';
import { X, Calendar, FileText, Clock } from 'lucide-react';

const ModalVerEvento = ({ isOpen, onClose, evento }) => {
  if (!isOpen || !evento) return null;

  const InfoRow = ({ icon: Icon, label, value }) => (
    <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
      <Icon className="w-5 h-5 text-[#c8a88c] mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm text-gray-600 mb-1">{label}</div>
        <div className="font-medium text-gray-900">{value || 'No especificado'}</div>
      </div>
    </div>
  );

  const getEventIcon = (tipo) => {
    const icons = {
      'Huracán': '🌀',
      'Tormenta Tropical': '⛈️',
      'Inundación': '🌊',
      'Deslizamiento': '⛰️',
      'Sequía': '☀️',
      'Incendio': '🔥',
      'Terremoto': '🌍'
    };
    return icons[tipo] || '⚠️';
  };

  const getDuracion = () => {
    if (!evento.FechaInicio || !evento.FechaFin) return 'No especificada';
    
    const inicio = new Date(evento.FechaInicio);
    const fin = new Date(evento.FechaFin);
    const dias = Math.ceil((fin - inicio) / (1000 * 60 * 60 * 24));
    
    if (dias === 0) return '1 día';
    if (dias === 1) return '2 días';
    return `${dias + 1} días`;
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex items-center justify-between z-10">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <span className="text-4xl">{getEventIcon(evento.Tipo)}</span>
              <div>
                <h2 className="text-2xl font-bold text-gray-900">
                  {evento.Fenomeno}
                </h2>
                <p className="text-sm text-gray-500 mt-1">
                  {evento.Tipo} • {evento.Año}
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-6 h-6 text-gray-600" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-6">
          {/* Información General */}
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Información del Evento</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <InfoRow
                icon={FileText}
                label="Tipo de Evento"
                value={evento.Tipo}
              />
              <InfoRow
                icon={Calendar}
                label="Año"
                value={evento.Año}
              />
            </div>
          </div>

          {/* Período del Evento */}
          {(evento.FechaInicio || evento.FechaFin) && (
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Período</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {evento.FechaInicio && (
                  <InfoRow
                    icon={Calendar}
                    label="Fecha de Inicio"
                    value={new Date(evento.FechaInicio).toLocaleDateString('es-HN', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  />
                )}
                {evento.FechaFin && (
                  <InfoRow
                    icon={Calendar}
                    label="Fecha de Fin"
                    value={new Date(evento.FechaFin).toLocaleDateString('es-HN', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  />
                )}
                {evento.FechaInicio && evento.FechaFin && (
                  <InfoRow
                    icon={Clock}
                    label="Duración"
                    value={getDuracion()}
                  />
                )}
              </div>
            </div>
          )}

          {/* Estadísticas (placeholder para futuras implementaciones) */}
          <div className="bg-gradient-to-br from-[#c8a88c]/10 to-[#F3A108]/10 rounded-xl p-6 border border-[#c8a88c]/20">
            <h3 className="text-lg font-semibold text-gray-900 mb-3">Resumen</h3>
            <p className="text-gray-700">
              Este evento está registrado en el sistema y puede ser asociado a múltiples emergencias en diferentes municipios.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6">
          <button
            onClick={onClose}
            className="w-full px-6 py-3 bg-gray-100 text-gray-700 rounded-lg font-medium hover:bg-gray-200 transition-colors"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalVerEvento;